// extracted by mini-css-extract-plugin
export default {"primary":"Button_primary__9MLUH"};